const common = {
  storageKey: "ilab",
};

const development = {
  ...common,
  authUri: "https://auth-cf24-dev.jungkyungsuk-com.workers.dev",
  apiUri: "https://api-st-cf24-dev.jungkyungsuk-com.workers.dev",
};

const production = {
  ...common,
  authUri: "https://auth-cf24-prod.jungkyungsuk-com.workers.dev",
  apiUri: "https://api-st-cf24-prod.jungkyungsuk-com.workers.dev",
};

const config = process.env.NODE_ENV === "production" ? production : development;

export default config;
